<script setup lang="ts">
import { Xmark } from "@iconoir/vue";
import { onMounted, useTemplateRef } from "vue";

const content = defineModel<string>({ required: true });

const { saving, hideContent } = defineProps<{
  saving: boolean;
  hideContent?: boolean;
}>();

defineEmits<{
  submit: [];
  cancel: [];
}>();

const textarea = useTemplateRef("textarea");

onMounted(() => {
  if (!hideContent) textarea.value?.focus();
});
</script>

<template>
  <form class="column" @submit.prevent="$emit('submit')">
    <template v-if="!hideContent">
      <label for="edit-conversation-content" class="visually-hidden"
        >Notiz bearbeiten</label
      >
      <textarea
        id="edit-conversation-content"
        ref="textarea"
        v-model="content"
        rows="8"
      ></textarea>
    </template>
    <div class="row row-end">
      <button
        class="button button--secondary"
        type="reset"
        @click="$emit('cancel')"
      >
        <Xmark />Abbrechen
      </button>
      <button class="button" type="submit" :disabled="saving">Speichern</button>
    </div>
  </form>
</template>
